// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/catalog_filtered_set_items_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogFilteredSetItemsDatatable } from "./constants";
import type {
  AppsCatalogFilteredSetItemsDatatableParams,
  AppsCatalogFilteredSetItemsDatatableResult,
} from "./types";

export const getDataTableAppsCatalogFilteredSetItemsDatatable = reactQueryTableFetcherAdapter(
  appsCatalogFilteredSetItemsDatatable,
  (
    signal: AbortSignal,
    {
      appGroupId,
      catalogId,
      sortRandom,
      sortField,
      sortOrder,
      filters,
      userId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
    }: AppsCatalogFilteredSetItemsDatatableParams
  ): Promise<AppsCatalogFilteredSetItemsDatatableResult> => {
    return fetch(
      "/apps/catalog_filtered_set_items_datatable",
      "GET",
      {
        groupby,
        limit,
        start,
        app_group_id: appGroupId,
        catalog_id: catalogId,
        sort_random: sortRandom,
        sort_field: sortField,
        filters: filters,
        sort_order: sortOrder,
        user_id: userId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
